import React from 'react';
import { FunctionField, TextField, useTranslate } from 'react-admin';
import { makeStyles } from '@material-ui/core';
import keyBy from 'lodash/keyBy';
import ArrayWithPaginationField from '../../../base/components/ra/fields/arrayWithPagination.field';
import CustomLinkField from '../../../base/components/ra/fields/customLink.field';
import resourceSlug from '../../../constant/resource-slug';
import { transformIdValue } from '../../../services/util/stringUtil';
import { ID_EMPTY } from '../../../constant';
import { INVOICE_SERVICE } from '../../../constant/invoice';
import { useGetGroupRoyalty } from './utils';
import { useHasReadInvoicePermission } from '../../group/components/utils';

const CurrenciesTable = (props) => {
  const classes = useStyles();
  const t = useTranslate();
  const hasReadInvoicePermission = useHasReadInvoicePermission();
  const brandRoyalty = keyBy(props.record?.royalty || [], 'invoiceService');
  const groupRoyalty = useGetGroupRoyalty(
    props.record?.group?.id,
    (!brandRoyalty[INVOICE_SERVICE.MKT_FREE_SPIN] || !brandRoyalty[INVOICE_SERVICE.MONTHLY_GGR]) &&
      hasReadInvoicePermission,
  );

  return (
    <ArrayWithPaginationField label={false} {...props}>
      <CustomLinkField
        sortable={false}
        source="id"
        href={(record) => `/#/${resourceSlug.CURRENCY}/${record.id}/show`}
        title={(record) => (record.id ? transformIdValue(record.id) : ID_EMPTY)}
      />
      <TextField source="name" sortable={false} label="resources.group.fields.name" />
      <TextField source="code" sortable={false} label="resources.currency.fields.code" />
      {hasReadInvoicePermission && (
        <FunctionField
          label={`common.invoiceServiceRoyalty.${INVOICE_SERVICE.MONTHLY_GGR}`}
          render={(record) => {
            const defaultMonthlyRoyaltyRate = {
              ...groupRoyalty,
              ...brandRoyalty,
            }[INVOICE_SERVICE.MONTHLY_GGR]?.value;

            const monthlyRoyaltyRate = record?.royalty?.find?.(
              (item) => item.invoiceService === INVOICE_SERVICE.MONTHLY_GGR,
            )?.value;

            const rate = monthlyRoyaltyRate || defaultMonthlyRoyaltyRate;
            const isDefault = rate === defaultMonthlyRoyaltyRate;
            return rate ? (
              <>
                {`${rate}%`}{' '}
                <span className={isDefault ? classes.defaultText : classes.customText}>
                  {`(${isDefault ? t('common.text.default') : t('common.text.custom')})`}
                </span>
              </>
            ) : (
              '-'
            );
          }}
        />
      )}
      {hasReadInvoicePermission && (
        <FunctionField
          label={`common.invoiceServiceRoyalty.${INVOICE_SERVICE.MKT_FREE_SPIN}`}
          render={(record) => {
            const defaultMktRoyaltyRate = {
              ...groupRoyalty,
              ...brandRoyalty,
            }[INVOICE_SERVICE.MKT_FREE_SPIN]?.value;

            const mktRoyaltyRate = record?.royalty?.find?.(
              (item) => item.invoiceService === INVOICE_SERVICE.MKT_FREE_SPIN,
            )?.value;

            const rate = mktRoyaltyRate || defaultMktRoyaltyRate;
            const isDefault = rate === defaultMktRoyaltyRate;
            return rate ? (
              <>
                {`${rate}%`}{' '}
                <span className={isDefault ? classes.defaultText : classes.customText}>
                  {`(${isDefault ? t('common.text.default') : t('common.text.custom')})`}
                </span>
              </>
            ) : (
              '-'
            );
          }}
        />
      )}
    </ArrayWithPaginationField>
  );
};

export default CurrenciesTable;

const useStyles = makeStyles((theme) => ({
  customText: {
    fontSize: 12,
    fontStyle: 'italic',
    color: theme.palette.primary.main,
  },
  defaultText: {
    fontSize: 12,
    fontStyle: 'italic',
    color: theme.palette.grey[600],
  },
}));
